<template>
    <div v-if="!hidden" class="table-menu" @wheel.stop
     @mousedown="startDrag"
     @mouseenter="$emit('diableMapDragAndZoom')"
     @mouseleave="$emit('enableMapDragAndZoom')"
    >  
      <!-- 关闭按钮 -->
      <button class="close-button" @click="$emit('closeSearchMenu')">×</button>
      <!-- 表格标题 -->
      <h2 class="table-title">{{ tableData.title }}</h2>  
      <table>
          <thead class="table-header">            
              <!-- 动态生成表头 -->
              <template v-if="tableData.data.length > 0">
                  <tr>
                      <td>{{ tableData.columnHeaders.firstColumnTitle }}</td>
                      <td v-for="(col, colindex) in tableData.columnHeaders.columns" :key="colindex">{{ col.label }}</td>
                      <td>{{ tableData.columnHeaders.lastColumnTitle }}</td>
                  </tr>
              </template>
              <th v-else>{{ tableData.message }}</th>
          </thead>  
          <tbody class="table-body">
              <!-- 循环渲染表格数据 -->
              <template v-if="tableData.data.length > 0">
                  <tr 
                      v-for="(row, rowIndex) in tableData.data" 
                      :key="rowIndex"
                      @mouseover="highlightRow(rowIndex)"
                      @mouseout="unhighlightRow(rowIndex)"
                      :class="{ 'highlight': highlightedRow === rowIndex }"
                  >
                      <td>{{ rowIndex + 1 }}</td>
                      <td v-for="(col, colindex) in tableData.columnHeaders.columns" :key="colindex">{{ row[col.name] }}</td>
                      <td><a v-on:click="$emit('clickPatchDetail',row['WYBH'])">查看详情</a></td>
                  </tr>
              </template>
          </tbody>          
      </table>
    </div>    
  </template>
  
  <script>
  export default {
    name: 'SearchMenu',
    props: {
      tableData: {
        type: Object,
        default: null,
      },
      hidden: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        highlightedRow: null,
        isDragging: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0
      };
    },
    methods: {
      highlightRow(index) {
        this.highlightedRow = index;
      },
      unhighlightRow() {
        this.highlightedRow = null;
      },
      startDrag(event) {
            event.stopPropagation(); // 阻止事件冒泡
            this.isDragging = true;
            this.startX = event.clientX;
            this.startY = event.clientY;
            this.offsetX = this.$el.offsetLeft;
            this.offsetY = this.$el.offsetTop;
            document.addEventListener('mousemove', this.drag);
            document.addEventListener('mouseup', this.stopDrag);
        },
        drag(event) {
            event.stopPropagation(); // 阻止事件冒泡
            if (this.isDragging) {
                const dx = event.clientX - this.startX;
                const dy = event.clientY - this.startY;
                this.$el.style.left = `${this.offsetX + dx}px`;
                this.$el.style.top = `${this.offsetY + dy}px`;
            }
        },
        stopDrag() {
            this.isDragging = false;
            document.removeEventListener('mousemove', this.drag);
            document.removeEventListener('mouseup', this.stopDrag);
        }
    }
  };
  </script>
  
  <style scoped>
  .table-menu {
    width: 25%;
    top: 20vh;   
    left: 20px;
    overflow-x: auto; /* 确保表格内容超出高度时出现滚动条 */
    position: fixed;
    z-index: 1002;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    background-color: #f0f0f0;
    padding: 10px;
  }
  
  .close-button {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
    z-index: 1004;
  }
  
  .table-title {
    background-color: #e0e0e0; /* 标题栏背景颜色 */
    padding: 5px;
    margin: -10px -10px 10px -10px; /* 调整标题栏的边距 */
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    position:relative;
    top:0;
    z-index: 1003;
  }
  
  .table-container {
    height: 100%; /* 减去标题栏的高度 */  
    overflow-y: auto;
    position: relative;
  }
  
  .table-header{
      position:sticky;
      top:0;
      background-color: rgb(141, 164, 167);
      font-weight: bold;
      z-index: 1003;
  }
  
  .table-body {
      display:block;
      overflow-y: auto;
      position: relative;  
      max-height: 50vh;  
  }
  
  table {    
    border-collapse: collapse;
    border:1px solid #ccc;
    table-layout: auto;
  }
  
  thead,
  tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  
  th,
  td{
      font-size: 12px;
      border: 1px solid #ccc;
      padding: 5px;
      text-align: center;
  }
  
  /* 高亮显示的 CSS 类 */
  .highlight {
    background-color: #e0f7fa; /* 可以根据需要调整高亮颜色 */
    cursor: pointer;
  }
  </style>
  